import React from 'react'
import { Button, Loader } from 'components/UIElements'
import { DEFAULT_COMPLETION_METHOD } from 'utils/constants'
import '../stylesheets/VisitTable.scss'
import '../stylesheets/VisitSchedules.scss'

const ViewVisitInstrumentsSection = ({
    visitId,
    instrumentsPayload,
    isLoading,
    onClose,
    getInstrumentStatusText,
}) => {
    const instrumentsList = (instrumentsPayload?.[visitId]?.instruments || instrumentsPayload?.instruments || [])

    return (
        <>
            <div className='associated-instruments'>
                <div className='title text-blue'>Associated Instruments Details</div>
                {isLoading ? (
                    <Loader inContainer size={20} />
                ) : instrumentsList.length ? (
                    <table className='d3-sortable-table'>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Status</th>
                                    <th>Completion Method</th>
                            </tr>
                        </thead>
                        <tbody>
                            {instrumentsList
                                .slice()
                                .sort(
                                    (a, b) => (a?.instrument_schedule?.deploy?.days_offset || 0) - (b?.instrument_schedule?.deploy?.days_offset || 0),
                                )
                                .map((inst, i) => {
                                    const name = inst?.instrument_title || `Instrument #${i + 1}`
                                    const statusText = getInstrumentStatusText ? getInstrumentStatusText(inst) : ''
                                    const completionMethod = inst?.instance_completion_method || DEFAULT_COMPLETION_METHOD
                                    return (
                                        <tr key={`inst-${visitId}-${i}`}>
                                            <td>{name}</td>
                                            <td>{statusText}</td>
                                            <td>{completionMethod}</td>
                                        </tr>
                                    )
                                })}
                        </tbody>
                    </table>
                ) : (
                    <div>No associated instruments</div>
                )}
                <div className='bottom flexed' style={{ marginTop: 10 }}>
                    <Button grey id='view-instruments-close' content='Close' onClick={onClose} />
                </div>
            </div>
        </>
    )
}

export default ViewVisitInstrumentsSection